import { useState, useEffect } from "react";
import React from "react";
import { getEmployeePreviousEmploymentInfo, postEmployeePreviousEmploymentInfo, getNotificationId } from "../service/DirectorAPI";
import moment from "moment";
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import $ from 'jquery';
import { connect } from 'react-redux';
import { encryptStorage } from '../constant'

function PreviousEmploymentDetails(props) {

    let dataObj = {
        id: "",
        NameOfCompany: "",
        Designation: "",
        DateOfJoining: "",
        DateOfReleiving: "",
        LastDrawnCtc: "",
        EmailId: ""
    };

    const [previousEmploymentData, setpreviousEmploymentData] = useState(dataObj);

    let oldvalue = {
        NameOfCompany: "",
        Designation: "",
        DateOfJoining: "",
        DateOfReleiving: "",
        LastDrawnCtc: "",
        EmailId: ""
    }
    let EditArray = [];
    const [editArray, seteditArray] = useState(EditArray);
    const [Oldvalue, setOldvalue] = useState(oldvalue);
    const [pagemode, setpagemode] = useState("false");
    const [viewmode, setviewmode] = useState("false");
    const [EmpId, setEmpId] = useState("");
    const [submit, setSubmit] = useState("Save");
    const [selectedFile, setselectedFile] = useState("");
    const [isRejexValid, setIsRejexValid] = useState(true);
    const [hideForm, setHideForm] = useState(true);
    const [reportstoId, setReportstoId] = useState("");

    let loginEmpId = encryptStorage.getItem("employeeId");
    const [DisableSubmitBtn, setDisableSubmitBtn] = useState(false);
    let role = encryptStorage.getItem("role");


    useEffect(() => {
         setDisableSubmitBtn(false);

        if (props.IsPreEmployClicked) {

            // let element = document.getElementById("removeScroll");
            // element.classList.add("removeScroll");

            $("body").addClass("removeScroll");

            setHideForm(false);
            if (props.empId != undefined) {
                setEmpId(props.empId)
            }
            if (props.Mode != undefined) {
                if (props.Mode == 'Edit') {
                    setpagemode('true')
                    setSubmit('Update')
                } else {
                    setpagemode('false')
                    setSubmit('Save')
                }
            }
            if (props.Id != undefined) {

                let objedit = {

                    emp_id: props.empId,
                    id: props.Id,
                    reports_to: loginEmpId,
                    role: role,
                };

                selecteditarray(objedit);
            }
        }

    }, [props])

    let rejexvalidation = {

        LastDrawnCtc: ""

    }
    const [rejexMessage, setRejexMessage] = useState(rejexvalidation);
    const [notification, setNotification] = useState([]);

    const OnChangeName = (e) => {

        e.preventDefault();
        var regexItem;
        var checkValid;

        if (e.target.name == "LastDrawnCtc") {
            regexItem = new RegExp("^[0-9.]*$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.LastDrawnCtc = "Enter a Valid CTC"
                setRejexMessage({ ...rejexMessage });
                setIsRejexValid(false);

            } else {
                rejexMessage.LastDrawnCtc = ""
                setRejexMessage({ ...rejexMessage });
                setIsRejexValid(true);
            }
        }


        setpreviousEmploymentData({ ...previousEmploymentData, [e.target.name]: e.target.value });
        setmessage({ ...message, [e.target.name]: "" });
    };


    let validationFields = {
        NameOfCompany: "",
        Designation: "",
        DateOfJoining: "",
        DateOfReleiving: "",
        LastDrawnCtc: "",
        EmailId: ""

    }
    const [message, setmessage] = useState(validationFields);
    const validation = () => {

     

        if (previousEmploymentData.NameOfCompany.trim() == "") {

            message.NameOfCompany = "Name of the previous company is required"
            setmessage({ ...message });
        } else {
            message.NameOfCompany = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(previousEmploymentData.NameOfCompany)
            if (checkregex) {

                message.NameOfCompany = "Enter a Valid Name of the previous company"
                setmessage({ ...message });
            } else {
                message.NameOfCompany = ""
                setmessage({ ...message });

            }

        }
        if (previousEmploymentData.Designation.trim() == "") {

            message.Designation = "Designation is required"
            setmessage({ ...message });

        } else {
            message.Designation = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(previousEmploymentData.Designation)
            if (checkregex) {

                message.Designation = "Enter a Valid Designation"
                setmessage({ ...message });
            } else {
                message.Designation = ""
                setmessage({ ...message });
            }

        }
        if (previousEmploymentData.DateOfJoining == "") {

            message.DateOfJoining = "Joining date in the previous company is required"
            setmessage({ ...message });

        } else {
            message.DateOfJoining = ""
            setmessage({ ...message });

        }
        if (previousEmploymentData.DateOfReleiving == "") {

            message.DateOfReleiving = "Relieving date of the previous company is required"
            setmessage({ ...message });

        } else if (previousEmploymentData.DateOfJoining != "" && previousEmploymentData.DateOfReleiving != "" && previousEmploymentData.DateOfJoining >= previousEmploymentData.DateOfReleiving) {

            message.DateOfReleiving = "Enter a valid Date of Relieving"
            setmessage({ ...message });

        } else {
            message.DateOfReleiving = ""
            setmessage({ ...message });

        }

        // if (previousEmploymentData.DateOfJoining != "" && previousEmploymentData.DateOfReleiving != "" && previousEmploymentData.DateOfJoining >= previousEmploymentData.DateOfReleiving) {

        //     message.DateOfReleiving = "Enter a valid Date of Relieving"
        //     setmessage({ ...message });

        // } else {
        //     message.DateOfReleiving = ""
        //     setmessage({ ...message });

        // }


        if (previousEmploymentData.LastDrawnCtc == "") {

            message.LastDrawnCtc = "Last Drawn CTC is required"
            setmessage({ ...message });

        } else {
            message.LastDrawnCtc = ""
            setmessage({ ...message });


        }

        // if (previousEmploymentData.EmailId == "") {

        //     message.EmailId = "Email ID of the Team member is required"
        //     setmessage({ ...message });

        // } else {
        //     message.EmailId = ""
        //     setmessage({ ...message });

        // }

    }



    const submitClick = async () => {

        try {
              setDisableSubmitBtn(true);
            validation();

            let isRejexValid = true;
            if (message.NameOfCompany != "" || message.Designation != "" || rejexMessage.LastDrawnCtc != "" || message.DateOfReleiving != "") {
                isRejexValid = false;
            } else {
                isRejexValid = true;
            }


            if (pagemode == "false" && isRejexValid == true) {
                if (
                    previousEmploymentData.NameOfCompany.trim() != "" &&
                    previousEmploymentData.Designation.trim() != "" &&
                    previousEmploymentData.DateOfJoining != "" &&
                    previousEmploymentData.DateOfReleiving != "" &&
                    previousEmploymentData.LastDrawnCtc != ""
                    //previousEmploymentData.EmailId != ""
                ) {
                    let insertdata = {
                        request_type: "Insert", //
                        emp_id: EmpId, //
                        login_emp_id: loginEmpId, //
                        role: role,//
                        name_of_company: previousEmploymentData.NameOfCompany,
                        designation: previousEmploymentData.Designation,
                        ctc: previousEmploymentData.LastDrawnCtc,
                        date_of_join: previousEmploymentData.DateOfJoining,
                        date_of_releave: previousEmploymentData.DateOfReleiving,
                        email_id: previousEmploymentData.EmailId
                    };

                    let responsedata = await postEmployeePreviousEmploymentInfo(insertdata);
                    if (responsedata.data.status == 200) {
                        let valiclearoption = {
                            id: "",
                            NameOfCompany: "",
                            Designation: "",
                            LastDrawnCtc: "",
                            DateOfJoining: "",
                            DateOfReleiving: "",
                            EmailId: ""
                        };
                        setpreviousEmploymentData(valiclearoption);

                        props.setIsPreEmployClicked(false);
                        props.getEmployeePreviousEmploymentGrid(false);
                        cancelClick();
                        props.showToast('Submitted', 'Submitted Succesfully');
                    }

                }
            }
            else if (pagemode == "true" && isRejexValid == true) {

                if (((role == "Hr Manager" || role == "Hr") && loginEmpId != EmpId) || (role == "Hr Manager" && loginEmpId == EmpId && reportstoId == loginEmpId)) {
                    if (
                        previousEmploymentData.NameOfCompany.trim() != "" &&
                        previousEmploymentData.Designation.trim() != "" &&
                        previousEmploymentData.DateOfJoining != "" &&
                        previousEmploymentData.DateOfReleiving != "" &&
                        previousEmploymentData.LastDrawnCtc != ""
                        //previousEmploymentData.EmailId != ""
                    ) {
                        let updatedata = {
                            request_type: "Update", //
                            emp_id: EmpId, //
                            login_emp_id: loginEmpId, //
                            role: role,//
                            id: previousEmploymentData.id,
                            name_of_company: previousEmploymentData.NameOfCompany,
                            designation: previousEmploymentData.Designation,
                            ctc: previousEmploymentData.LastDrawnCtc,
                            date_of_join: previousEmploymentData.DateOfJoining,
                            date_of_releave: previousEmploymentData.DateOfReleiving,
                            email_id: previousEmploymentData.EmailId

                        };


                        let responsedata = await postEmployeePreviousEmploymentInfo(updatedata);
                        if (responsedata.data.status == 200) {

                            let valiclearoption = {
                                id: "",
                                NameOfCompany: "",
                                Designation: "",
                                LastDrawnCtc: "",
                                DateOfJoining: "",
                                DateOfReleiving: "",
                                EmailId: ""
                            };
                            setpreviousEmploymentData(valiclearoption);

                            props.setIsPreEmployClicked(false);
                            props.getEmployeePreviousEmploymentGrid(false);
                            cancelClick();
                            props.showToast('Updated', 'Updated Succesfully');
                        }
                    }


                } else if (role == "Team Member" || loginEmpId == EmpId) {
                    if (
                        previousEmploymentData.NameOfCompany.trim() != "" &&
                        previousEmploymentData.Designation.trim() != "" &&
                        previousEmploymentData.DateOfJoining != "" &&
                        previousEmploymentData.DateOfReleiving != "" &&
                        previousEmploymentData.LastDrawnCtc != ""
                        // previousEmploymentData.EmailId != ""
                    ) {

                        let newvalue = {
                            name_of_company: previousEmploymentData.NameOfCompany,
                            designation: previousEmploymentData.Designation,
                            ctc: previousEmploymentData.LastDrawnCtc,
                            date_of_join: previousEmploymentData.DateOfJoining,
                            date_of_releave: previousEmploymentData.DateOfReleiving,
                            email_id: previousEmploymentData.EmailId
                        }

                        let oldvalue = {
                            name_of_company: Oldvalue.NameOfCompany,
                            designation: Oldvalue.Designation,
                            ctc: Oldvalue.LastDrawnCtc,
                            date_of_join: Oldvalue.DateOfJoining,
                            date_of_releave: Oldvalue.DateOfReleiving,
                            email_id: Oldvalue.EmailId
                        }

                        let NewValue = Object.keys(newvalue);
                        let OldValue = Object.keys(oldvalue);

                        let log_data = '{';
                        for (let i = 0; i <= NewValue.length; i++) {
                            if (newvalue[NewValue[i]] != oldvalue[OldValue[i]]) {

                                log_data += '"' + NewValue[i] + '"' + ':' + '"' + "'" + newvalue[NewValue[i]] + "'" + ',' + "'" + oldvalue[OldValue[i]] + "'" + '"' + ',';
                            }
                            if (i == NewValue.length) {

                                log_data = log_data.slice(0, -1);
                                log_data = log_data + "}";
                            }
                        }

                        if (log_data != '{' && log_data != '}') {
                            let logData = JSON.parse(log_data);

                            let updatedata = {
                                request_type: "Update", //
                                emp_id: EmpId, //
                                login_emp_id: loginEmpId, //
                                category_id: previousEmploymentData.id,
                                category: "prev_employment",
                                status: "Pending",
                                role: "Team Member",
                                log_data: logData

                            };


                            let emp = [];
                            notification.map((obj, index) => {

                                emp.push(obj.emp_id);
                            });

                            if (Object.keys(logData).length > 0) {

                                let responsedata = await postEmployeePreviousEmploymentInfo(updatedata);
                                if (responsedata.data.status == 200) {
                                    let profileRequestId = responsedata.data.ResponseData[1];
                                    await NotificationTrigger({ title: "Profile Update", message: 'Profile Request', route: '/profileupdate', state: { state: { profileRequestId: profileRequestId } }, to_employee: emp, by: loginEmpId }, emp, props.websocket)

                                    let valiclearoption = {
                                        id: "",
                                        NameOfCompany: "",
                                        Designation: "",
                                        LastDrawnCtc: "",
                                        DateOfJoining: "",
                                        DateOfReleiving: "",
                                        EmailId: ""
                                    };
                                    setpreviousEmploymentData(valiclearoption);
                                    props.setIsPreEmployClicked(false);
                                    cancelClick();
                                    props.showToast('Profile Request submitted', 'Changes will be reflected after the approval');
                                }
                            }
                        } else { cancelClick(); }
                         
                    }


                }
            }
            setDisableSubmitBtn(false);
        } catch (e) {
             setDisableSubmitBtn(false);

        }

    }

    const cancelClick = () => {

        let valiclearoption = {
            id: "",
            NameOfCompany: "",
            Designation: "",
            DateOfJoining: "",
            DateOfReleiving: "",
            LastDrawnCtc: "",
            EmailId: ""

        };
        setpreviousEmploymentData(valiclearoption);

        let validationFields = {
            NameOfCompany: "",
            Designation: "",
            DateOfJoining: "",
            DateOfReleiving: "",
            LastDrawnCtc: "",
            EmailId: ""

        }
        setmessage(validationFields);

        rejexMessage.LastDrawnCtc = ""
        setRejexMessage({ ...rejexMessage });

        props.setIsPreEmployClicked(false);
        setHideForm(true);
        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");

        $("body").removeClass("removeScroll");
    }


    const selecteditarray = async (objedit) => {


        try {
            let responsedata = await getEmployeePreviousEmploymentInfo(objedit);
            seteditArray(responsedata.data.ResponseData[0]);

            if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {

                // EditLoadDatacurrentstate(responsedata.data.ResponseData[0][0].country);
                // EditLoadDataperstate(responsedata.data.ResponseData[0][0].country);

                let dateofjoining = moment(new Date(responsedata.data.ResponseData[0][0].date_of_join));
                let olddateofjoining = dateofjoining.format("YYYY-MM-DD");

                let dateofreleiving = moment(new Date(responsedata.data.ResponseData[0][0].date_of_releave));
                let olddateofreleiving = dateofreleiving.format("YYYY-MM-DD");

                let oldvalueobj = {

                    NameOfCompany: responsedata.data.ResponseData[0][0].name_of_company,
                    Designation: responsedata.data.ResponseData[0][0].designation,
                    DateOfJoining: olddateofjoining,
                    DateOfReleiving: olddateofreleiving,
                    LastDrawnCtc: responsedata.data.ResponseData[0][0].ctc,
                    EmailId: responsedata.data.ResponseData[0][0].email_id
                };
                setOldvalue(oldvalueobj);







                let newdateofjoining = dateofjoining.format("YYYY-MM-DD");
                let newdateofreleiving = dateofreleiving.format("YYYY-MM-DD");

                let valiDateobj1 = {
                    id: responsedata.data.ResponseData[0][0].id,
                    NameOfCompany: responsedata.data.ResponseData[0][0].name_of_company,
                    Designation: responsedata.data.ResponseData[0][0].designation,
                    DateOfJoining: newdateofjoining,
                    DateOfReleiving: newdateofreleiving,
                    LastDrawnCtc: responsedata.data.ResponseData[0][0].ctc,
                    EmailId: responsedata.data.ResponseData[0][0].email_id

                };
                setpreviousEmploymentData(valiDateobj1);
            }

            let NotaficationData = await getNotificationId(objedit);
            setNotification(NotaficationData.data.ResponseData[0]);
            setReportstoId(NotaficationData?.data?.ResponseData[0][0]?.emp_id);

        } catch (e) {

        }
    };

    return (
        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }}
            hidden={hideForm}
            //id="previousemploymentpopup" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="previousemploymentLabel" aria-hidden="true"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="previousemploymentLabel">
                            Previous Employment
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => {
                                cancelClick();
                            }}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="row mb-4">
                            {/* <h1 className="profile-popup-subheader">Company 1</h1> */}
                            <div className="col-md-6 mb-4">
                                <label htmlFor="previous-emp-name" className="form-label hive-form-label">
                                    Name of the Company<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    id="previous-emp-name"
                                    aria-describedby="Company Name"
                                    placeholder="Enter the name of the company"
                                    maxLength={255}
                                    name="NameOfCompany"
                                    value={previousEmploymentData.NameOfCompany}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.NameOfCompany ? <label className="hive-form-mandatory">{message.NameOfCompany}</label> : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="previous-emp-designation" className="form-label hive-form-label">
                                    Designation<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    id="previous-emp-designation"
                                    aria-describedby="Designation"
                                    placeholder="Enter the Designation"
                                    maxLength={255}
                                    name="Designation"
                                    value={previousEmploymentData.Designation}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.Designation ? <label className="hive-form-mandatory">{message.Designation}</label> : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="previous-emp-CTC" className="form-label hive-form-label">
                                    Last Drawn CTC<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    id="previous-emp-CTC"
                                    aria-describedby="CTC"
                                    placeholder="Enter the CTC"
                                    name="LastDrawnCtc"
                                    value={previousEmploymentData.LastDrawnCtc}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.LastDrawnCtc ? <label className="hive-form-mandatory">{message.LastDrawnCtc}</label> : null}
                                {rejexMessage.LastDrawnCtc ? (
                                    <label className="hive-form-mandatory">{rejexMessage.LastDrawnCtc}</label>
                                ) : null}
                            </div>
                            <div className="col-md-3 mb-4">
                                <label htmlFor="previous-emp-date-issue" className="form-label hive-form-label">
                                    Date of Joining<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control hive-form-control"
                                    id="previous-emp-date-issue"
                                    aria-describedby="Date Issued"
                                    name="DateOfJoining"
                                    value={previousEmploymentData.DateOfJoining}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.DateOfJoining ? <label className="hive-form-mandatory">{message.DateOfJoining}</label> : null}
                            </div>
                            <div className="col-md-3 mb-4">
                                <label htmlFor="previous-emp-expiry" className="form-label hive-form-label">
                                    Date of Relieving<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control hive-form-control"
                                    id="previous-emp-expiry"
                                    aria-describedby="Expiry"
                                    name="DateOfReleiving"
                                    value={previousEmploymentData.DateOfReleiving}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.DateOfReleiving ? <label className="hive-form-mandatory">{message.DateOfReleiving}</label> : null}
                            </div>
                            {/* <div className="col-md-6 mb-4">
                                <label htmlFor="previous-emp-email" className="form-label hive-form-label">Email ID<span className="hive-form-mandatory">*</span></label>
                                <input type="text" className="form-control hive-form-control" id="previous-emp-email" aria-describedby="Email"
                                    maxLength={225} placeholder="Enter email id" name="EmailId" value={previousEmploymentData.EmailId} onChange={(e) => { OnChangeName(e); }} />
                                {message.EmailId ? <label className="hive-form-mandatory">{message.EmailId}</label> : null}

                            </div> */}
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button
                            type="button"
                            className="btn hive-btn-secondary"
                            data-bs-dismiss="modal"
                            onClick={() => {
                                cancelClick();
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn hive-btn-primary"
                            onClick={() => {
                                submitClick();
                            }}
                            disabled={DisableSubmitBtn}
                        >
                            {submit}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(PreviousEmploymentDetails)